import { render, staticRenderFns } from "./EditLbProduct.vue?vue&type=template&id=7fb65751&scoped=true"
import script from "./EditLbProduct.vue?vue&type=script&lang=js"
export * from "./EditLbProduct.vue?vue&type=script&lang=js"
import style0 from "./EditLbProduct.vue?vue&type=style&index=0&id=7fb65751&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb65751",
  null
  
)

export default component.exports